var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26,17.8V14.18H23.36a7,7,0,0,0-.87-2.12l1.82-1.85L21.8,7.67,19.94,9.5a7.79,7.79,0,0,0-2.13-.88V6H14.19V8.62a8.26,8.26,0,0,0-2.13.88L10.22,7.67,7.67,10.21l1.84,1.85a7.61,7.61,0,0,0-.83,2.12H6V17.8H8.64a7.31,7.31,0,0,0,.83,2.12L7.63,21.75l2.59,2.6,1.84-1.85a7.79,7.79,0,0,0,2.13.88V26h3.62V23.36a7.24,7.24,0,0,0,2.13-.89l1.86,1.88,2.51-2.59-1.85-1.84a7.71,7.71,0,0,0,.87-2.12ZM16,19.6A3.62,3.62,0,1,1,19.63,16,3.62,3.62,0,0,1,16,19.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarSettings);
export default __webpack_public_path__ + "static/media/toolbar-settings.142a26d9.svg";
export { ForwardRef as ReactComponent };